import { Object3D, TorusGeometry, MeshLambertMaterial, Mesh } from 'three';
import gsap from 'gsap';

export class MoveCursor extends Object3D{
	constructor(viewer){
		super();

		this.viewer = viewer;

		const geometry = new TorusGeometry( 0.1, 0.005, 9, 26 );
			  geometry.rotateX(Math.PI/2);

		const material = new MeshLambertMaterial({
			emissive: 0xffffff,
			opacity:0
		});

		material.transparent = true;

		this.torus = new Mesh( geometry, material );

		this.add(this.torus);

		this.visible = false;
		this.hidden  = true;

		this.position.y = 0.1;
	}

	get hidden(){ return this._hidden; }
	set hidden(hidden){
		if(this._hidden != hidden){
			hidden ? this.hide() : this.show();
			this._hidden = hidden;
		}
	}

	fadeOut(){
		const t = gsap.timeline();
		t.to(this.torus.scale, {
			duration:0.8,
			x:2,
			z:2,
			ease:'expo.out'
		}, 0);
		t.to(this.torus.material, {
			duration:0.2,
			opacity:0
		}, 0);

		return t;
	}

	show(){
		if(this.hiddenTm) this.hiddenTm.kill();

		this.viewer.domElement.classList.add('no-cursor');

		const t = gsap.timeline({
			onUpdate:this.viewer.requestRender
		});

		t.set(this, {visible:true});
		t.fromTo(this.torus.scale, {x:0.5, z:0.5}, {x:1, z:1, duration:0.7, ease:'expo.out', immediateRender:false});
		t.to(this.torus.material, { duration:0.3, opacity:1 }, 0);

		this.hiddenTm = t;

		return t;
	}

	hide(){
		if(this.hiddenTm) this.hiddenTm.kill();
		const t = gsap.timeline({
			onUpdate:this.viewer.requestRender
		});
		this.viewer.domElement.classList.remove('no-cursor');
		t.to(this.torus.scale, {x:0.5, z:0.5, duration:0.5, ease:'expo.out'});
		t.to(this.torus.material, {duration:0.2, opacity:0}, 0);
		t.set(this, {visible:false});

		this.hiddenTm = t;

		return t;
	}
}